import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { requiredValidator } from '@scisys-uim/uim-common';
import { SystemMessageSearchComponent } from '../search/system-message-search.component';
import { BusinessUnitService, SystemMessageService } from 'assets-service';
import { SystemMessage, BusinessUnit, BUSINESS_UNIT_TYPE, BUSINESS_UNIT_METADATA } from 'assets-model';


@Component({
  selector: 'app-system-message-dialog',
  templateUrl: './system-message-dialog.component.html',
  styleUrls: ['./system-message-dialog.component.scss']
})
export class SystemMessageDialogComponent implements OnInit {

  @ViewChild(SystemMessageSearchComponent) searchComponent: SystemMessageSearchComponent;

  public form: FormGroup;

  item: SystemMessage;

  businessUnitSelectionList: BusinessUnit[];

  constructor(
    private businessUnitService: BusinessUnitService,
    private systemMessageService: SystemMessageService,
    private dialogRef: MatDialogRef<SystemMessageDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any,
    private fb: FormBuilder,
    private dialog: MatDialog) {

    dialogRef.disableClose = true;
  }

  ngOnInit() {
    this.createEmptyItemAndForm();
    this.businessUnitLoadSelectionList();
  }

  createEmptyItemAndForm() {
    this.form = this.fb.group({
      businessUnit: [null, []],
      message: [null, [requiredValidator]],
      expiryDate: [null],
    });
    this.item = new SystemMessage();
    this.item.businessUnit = <any>"All Business Units";
  }

  ngAfterViewInit() {
  }

  public closeDialog() {
    this.dialogRef.close();
  }

  addSystemMessage() {
    if (typeof this.item.businessUnit == 'string') {
      this.item.businessUnit = null;
    }
    this.systemMessageService.create(this.item).subscribe(
      data => {
        this.createEmptyItemAndForm();
        this.searchComponent.forceSearch();
      }
    )
  }

  businessUnitDisplay(item: BusinessUnit) {
    if (item == null) {
      return "";
    }
    if (typeof item == 'string') {
      return item;
    }
    return BUSINESS_UNIT_TYPE.description(item);
  }

  businessUnitLoadSelectionList() {
    this.businessUnitService.findAll().subscribe(
      data => {
        this.businessUnitSelectionList = data.items;
      }
    );
  }

  businessUnitChanging(value: BusinessUnit, unsetDependents: boolean = true) { }

  businessUnitChanged(value: BusinessUnit, unsetDependents: boolean = true) {
  }

  businessUnitCompare(a: any, b: any) {
    if (typeof a == 'string' && typeof b == 'string') {
      return a == b;
    }
    return BUSINESS_UNIT_METADATA.equals(a, b);
  }


  messageChanging(value: string, unsetDependents: boolean = true) { }

  messageChanged(value: string, unsetDependents: boolean = true) {
  }

  expiryDateChanging(value: Date, unsetDependents: boolean = true) { }

  expiryDateChanged(value: Date, unsetDependents: boolean = true) {
  }
}
